import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

function subscribe(onChange: () => void): () => void {
  const query = window.matchMedia(QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

function getSnapshot(): boolean {
  return window.matchMedia(QUERY).matches;
}

/**
 * Whether this user has asked the system for less movement.
 *
 * CSS answers the same question on its own — `src/index.css` freezes every
 * animation under the media query — so this is only for motion JavaScript
 * drives: a line of text that swaps itself out, a frame the browser is not
 * animating. Anything that can be stopped in CSS should be stopped in CSS.
 *
 * Read through `useSyncExternalStore` because that is what a media query is: an
 * outside value that changes on its own. The preference can be turned on while
 * the tab is open, and a value captured once would be the one thing the setting
 * was meant to stop.
 */
export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot);
}
